export default function WaveTop() {
  return (
    <div className="wave-svg wave-top">
      <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <path fill="#045b57" d="M0,0 C480,80 960,0 1440,80 L1440,0 L0,0 Z" />
      </svg>
    </div>
  );
}
